import { render, staticRenderFns } from "./DonateButton.vue?vue&type=template&id=0014f049&scoped=true&"
import script from "./DonateButton.vue?vue&type=script&lang=js&"
export * from "./DonateButton.vue?vue&type=script&lang=js&"
import style0 from "./DonateButton.vue?vue&type=style&index=0&id=0014f049&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0014f049",
  null
  
)

export default component.exports